import { PurchasesTableColumnId } from 'src/utils/columns/purchases/purchasesColumnUtils.types';
import { Feature, PurchaseViewMode } from 'src/WebApiController';

import {
  ColumnPersonalizationFlags,
  ReportColumnPersonalizationFlags,
} from '../columnUtils.types';
import {
  PurchaseReportTableGroupingColumnId,
  PurchaseReportTableValueColumnId,
} from './purchasesReportColumnUtils.types';

export const PURCHASES_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  PurchasesTableColumnId,
  Partial<ColumnPersonalizationFlags>
> = {
  [PurchasesTableColumnId.BuyerUserId]: {},
  [PurchasesTableColumnId.Checkbox]: {
    isHiddenByDefault: true,
    isConfigurable: false,
  },
  [PurchasesTableColumnId.AccordianToggle]: {
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.FlattenedView,
    ],
    isConfigurable: false,
  },
  [PurchasesTableColumnId.PurchaseDate]: { isDateTime: true },
  [PurchasesTableColumnId.VendorOrderId]: { isRequired: true },
  [PurchasesTableColumnId.Vendor]: {
    isHiddenByDefault: true,
    requiredFeatures: [Feature.PurchaseTableV2],
  },
  [PurchasesTableColumnId.Id]: {
    isHiddenByDefault: true,
    requiredFeatures: [Feature.PurchaseInternalIdColumnDisplay],
  },
  [PurchasesTableColumnId.Payment]: {},
  [PurchasesTableColumnId.PaymentStatus]: {},
  [PurchasesTableColumnId.QualityControlState]: {},
  [PurchasesTableColumnId.TotalCost]: { isCurrency: true },
  [PurchasesTableColumnId.UnitCost]: { isCurrency: true },
  [PurchasesTableColumnId.Tickets]: {},
  [PurchasesTableColumnId.Orders]: {},
  [PurchasesTableColumnId.Shipment]: {},
  [PurchasesTableColumnId.Cost]: {},
  [PurchasesTableColumnId.Actions]: { isConfigurable: false, isRequired: true },
  [PurchasesTableColumnId.VendorAccountEmail]: { isHiddenByDefault: true },
  [PurchasesTableColumnId.CreatedBy]: { isHiddenByDefault: true },
  [PurchasesTableColumnId.Event]: {
    isHiddenByDefault: true,
    visibleViewModes: [PurchaseViewMode.TileView],
  },
  [PurchasesTableColumnId.Venue]: {
    isHiddenByDefault: true,
    visibleViewModes: [PurchaseViewMode.TileView],
  },
  [PurchasesTableColumnId.EventDate]: {
    isHiddenByDefault: true,
    visibleViewModes: [PurchaseViewMode.TileView],
  },
  [PurchasesTableColumnId.Seating]: {
    isHiddenByDefault: true,
    isNumeric: true, // Not actually numeric, but hack for numeric pills
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.EventTileView,
    ],
  },
  [PurchasesTableColumnId.Row]: {
    isHiddenByDefault: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.EventTileView,
    ],
    requiredFeatures: [Feature.RowSeatColumnSalePurchase],
  },
  [PurchasesTableColumnId.Seats]: {
    isHiddenByDefault: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.EventTileView,
    ],
    requiredFeatures: [Feature.RowSeatColumnSalePurchase],
  },
  [PurchasesTableColumnId.SeatTraits]: {
    isHiddenByDefault: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.EventTileView,
    ],
  },
  [PurchasesTableColumnId.TotalPayment]: {
    isHiddenByDefault: true,
    isCurrency: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.FlattenedView,
    ],
  },
  [PurchasesTableColumnId.TotalConvertedPayment]: {
    isHiddenByDefault: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.FlattenedView,
    ],
  },
  [PurchasesTableColumnId.PaymentConversionRate]: {
    isHiddenByDefault: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.FlattenedView,
    ],
  },
  [PurchasesTableColumnId.Commissions]: {
    isHiddenByDefault: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.FlattenedView,
    ],
  },
  [PurchasesTableColumnId.ConsigneeSellerAccountId]: {
    isHiddenByDefault: true,
    requiredFeatures: [Feature.EnableMasterUiViewForConsignors],
    consignorOnly: true,
  },
  [PurchasesTableColumnId.OutstandingBalance]: {
    isHiddenByDefault: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.FlattenedView,
    ],
  },
  [PurchasesTableColumnId.FaceValueCost]: {
    isHiddenByDefault: true,
    isCurrency: true,
    visibleViewModes: [
      PurchaseViewMode.TileView,
      PurchaseViewMode.EventTileView,
      PurchaseViewMode.FlattenedView,
    ],
    requiredFeatures: [Feature.FaceValueColumnPurchases],
  },
};

export const PURCHASES_TABLE_CUSTOM_COLUMN_PERSONALIZATION_CONFIG: Partial<ColumnPersonalizationFlags> =
  {
    isHiddenByDefault: true,
    isNumeric: true,
  };

export const PURCHASE_REPORT_V2_TABLE_COLUMN_PERSONALIZATION_CONFIG_OVERRIDES: Record<
  string,
  Partial<ReportColumnPersonalizationFlags>
> = {
  [PurchaseReportTableGroupingColumnId.PurchaseOrderDate]: {
    isDateTime: true,
  },
  [PurchaseReportTableGroupingColumnId.PurchaseCancellationDate]: {
    isDateTime: true,
  },
  [PurchaseReportTableValueColumnId.UnitCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [PurchaseReportTableValueColumnId.TotalCost]: {
    isNumeric: true,
    isCurrency: true,
  },
  [PurchaseReportTableValueColumnId.OutstandingBalance]: {
    isNumeric: true,
    isCurrency: true,
  },
  [PurchaseReportTableValueColumnId.TotalPaymentAmount]: {
    isNumeric: true,
    isCurrency: true,
  },
};
